//==================================================
// Polyfill for pseudo selector :placeholder-shown
// Author: Subash Selvaraj(github userid:sesubash)
//==================================================
(function () {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    var placeholderShownPolyfill = {
        init: function () {
            var self = this;
            document.querySelectorAll('[placeholder]').forEach(function (el) {
                if (el.getAttribute('placeholder') != "")
                    self.updatePlaceholder.call(el);

                $(el).on('change', self.updatePlaceholder);
                el.addEventListener('keyup', self.updatePlaceholder);
            });
        },

        updatePlaceholder: function () {
            this.classList[this.value ? 'remove' : 'add']('placeholder-shown');
        }

    };

    if (/^[c|i]|d$/.test(document.readyState || "")) {
        placeholderShownPolyfill.init();
    } else {
        document.addEventListener("DOMContentLoaded", placeholderShownPolyfill.init());
    }

    window.placeholderShownPolyfill = placeholderShownPolyfill;

})();
